module.exports = __webpack_public_path__ + "assets/32d108aaa8d87af290fd24cd1f00f331.png";